export const SETTINGS_GET = 'SETTINGS_GET'
export const SETTINGS_SET = 'SETTINGS_SET'



// WEBPACK FOOTER //
// ./src/store/actions/settings.js